function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        ", " {\n          min-width: ", ";\n          min-height: ", ";\n\n          svg {\n            width: ", ";\n            height: ", ";\n          }\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    fill: #ff6700;\n    -ms-transform: rotate(-90deg); /* IE 9 */\n    -webkit-transform: rotate(-90deg); /* Safari prior 9.0 */\n    transform: rotate(-90deg);\n  }\n\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  stroke: #e41e0a;\n  stroke-dasharray: 2, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ", " 1s ease-in infinite, ", " 6s ease-in infinite;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke-width: 0.25rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    15% {\n      stroke: ", ";\n    }\n\n    31% {\n      stroke: ", ";\n    }\n\n    47% {\n      stroke: ", ";\n    }\n\n    63% {\n      stroke: ", ";\n    }\n\n    79% {\n      stroke: ", ";\n    }\n\n    95% {\n      stroke: ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["  \n    0% {\n      stroke-dasharray: 2, 200;\n      stroke-dashoffset: 0;\n    }\n\n    85% {\n      stroke-dasharray: 200, 200;\n      stroke-dashoffset: -124px;\n    }\n\n    100% {\n      stroke-dasharray: 200, 200;\n      stroke-dashoffset: -124px;\n    }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { keyframes } from 'styled-components';
import styled, { css } from "../../theme";
import { getValuesWithMediaQueries } from "../../utils";
var availableColour = {
  black: '#23201c',
  blue: '#0077bd',
  darker_red: '#cc0b18',
  green: '#18a035',
  orange: '#f39100',
  red: '#e41e0a'
};
var dash = keyframes(_templateObject());
var color = keyframes(_templateObject2(), availableColour.red, availableColour.black, availableColour.orange, availableColour.darker_red, availableColour.blue, availableColour.green);
export var Circle = styled.circle(_templateObject3());
export var CircleWithPath = styled(Circle)(_templateObject4(), dash, color);
export var LoaderWrapper = styled.div(_templateObject5(), function (props) {
  return props.size && getValuesWithMediaQueries(props.theme, props.size).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        mediaQuery = _ref2[0],
        value = _ref2[1];

    return css(_templateObject6(), mediaQuery, value, value, value, value);
  });
});